const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_AUTH_URL = `${BASE_URL}/tagitstore_auth`;
const BASE_ENTITY_URL = `${BASE_URL}/tagitstore_entity`;
const BASE_USERS_URL = `${BASE_URL}/tagitstore_users`;
const BASE_FILES_URL = `${BASE_URL}/tagitstore_files`;
const BASE_MENU_URL = `${BASE_URL}/tagitstore_menu`;
const BASE_OFFER_URL = `${BASE_URL}/tagitstore_offer`;
const BASE_PRODUCT_URL = `${BASE_URL}/tagitstore_product`;
const BASE_SUBSCRIPTION_URL = `${BASE_URL}/tagitstore_subscription`;
const BASE_ROLE_URL = `${BASE_URL}/tagitstore_role`;

export const API_KEY = {
  AES_KEY: process.env.REACT_APP_AES_KEY,
  AES_IV: process.env.REACT_APP_AES_IV,
};
export const API_URL = {
  LOGIN: `${BASE_AUTH_URL}/mci/login`,
  LOGOUT: `${BASE_AUTH_URL}/user/logout/mci`,
  CHANGE_PASSWORD: `${BASE_AUTH_URL}/resetpassword/mci`,
  FORGOT_PASSWORD: `${BASE_AUTH_URL}/forgotpassword/mci`,
  FORGOT_PASSWORD_VERIFY: `${BASE_AUTH_URL}/forgotpassword/mci/verify`,
  SET_VERIFY: `${BASE_AUTH_URL}/mci/user/signup/verify`,
  REFRESH_TOKEN: `${BASE_AUTH_URL}/refreshToken/mci`,
  MENU: `${BASE_MENU_URL}/menu`,
  USER_MENU: `${BASE_MENU_URL}/menu/mci/role`,
  PRODUCT_CATEGORY: `${BASE_PRODUCT_URL}/productCategory`,
  PRODUCT: `${BASE_PRODUCT_URL}/product`,
  PRODUCT_FILE: `${BASE_FILES_URL}/upload/single`,
  PRODUCT_MAPPING: `${BASE_PRODUCT_URL}/productMapping`,
  ROLE: `${BASE_ROLE_URL}/role/mci`,
  ROLE_MAP: `${BASE_MENU_URL}/menu/multiple/rolemap/mci`,
  ROLE_MENU_MAP: `${BASE_MENU_URL}/menu/mci/allrole`,
  USER: `${BASE_AUTH_URL}/mci/user/signup`,
  USER_GET: `${BASE_USERS_URL}/users/mci`,
  USER_GET_ID: `${BASE_USERS_URL}/users/mci/role`,
  USER_SET_PASSWORD: `${BASE_AUTH_URL}/mci/user/signup/verify`,
  PLAN_AGAINST_PRODUCT: `${BASE_PRODUCT_URL}/productPlan/mci/product`,
  GETALL_ENTITY: `${BASE_ENTITY_URL}/entity`,
  PRICING: `${BASE_PRODUCT_URL}/productPlanPricing`,
  CLIENTS: `${BASE_USERS_URL}/users/boc`,
  ORDERS: `${BASE_SUBSCRIPTION_URL}/subscription`,
  SPECIFICOFFERCLIENTS: `${BASE_OFFER_URL}/specificOffer/clients`,
  SPECIFICOFFEREMAILS: `${BASE_OFFER_URL}/specificOffer/clientemails`,
  GETALLSPECIFICPRODUCT: `${BASE_PRODUCT_URL}/product`,
  SPECIFICOFFER: `${BASE_OFFER_URL}/specificOffer`,
  SUBCRIPTIONBYID: `${BASE_SUBSCRIPTION_URL}/subscription/mci/user`,
  GENERALOFFER_CREATE: `${BASE_OFFER_URL}/generalOffer`,
  GENERALOFFER: `${BASE_OFFER_URL}/generalOffer/active/mci`,
  GENERALOFFERBYID: `${BASE_OFFER_URL}/generalOffer/mci`,
  ORDER_EXPORT: `${BASE_SUBSCRIPTION_URL}/subscription/export`,
  INVOICE_PDF: `${BASE_SUBSCRIPTION_URL}/subscription/invoice/boc`,
  SUSCRIPTION_DETAIL: `${BASE_URL}/subscription/mci/user`,
  SUSCRIPTION_COUNT: `${BASE_SUBSCRIPTION_URL}/subscription/counts/mci`,
  ENQUIRY_GET: `${BASE_URL}/tagitstore_subscription/enquiry`,
  COMMUNICATION_TYPE: `${BASE_URL}/ccs_product/communicationType`,
  COMMUNICATION_TYPE_PLAN: `${BASE_URL}/ccs_product/productPlan`,
  COMMUNICATION_TYPE_PRODUCTMAPPING: `${BASE_URL}/ccs_product/productPlanMapping`,
};
export const ACTION_TYPES = {
  SHOW_SNACKBAR: "SHOW_SNACKBAR",
  HIDE_SNACKBAR: "HIDE_SNACKBAR",
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  AUTH: "AUTH",
  SET_MENU_ITEMS: "SET_MENU_ITEMS",
  CLEAR_MENU_ITEMS: "CLEAR_MENU_ITEMS",
};
